import React, { useContext } from "react";
import useGetConfig from "./useGetConfig";
import { ConfigResponse } from "@/app/api/config/route";

export const ConfigContext = React.createContext<ConfigResponse>({} as ConfigResponse);

export const ConfigProvider = ({ children }) => {
  const config = useGetConfig();

  if (config.isPending) {
    return <></>;
  } else if (config.isError) {
    return <p>Error: Config could not be found</p>;
  } else {
    return (
      <ConfigContext.Provider value={config.data}>{children}</ConfigContext.Provider>
    );
  }
};

export default function useConfig() {
  return useContext(ConfigContext);
}
